import './BenefitsTooltip.css';const benefitsTooltipTitle = "_benefitsTooltipTitle_3qxv9_1";
const benefitsTooltipContent = "_benefitsTooltipContent_3qxv9_47";
const benefitsTooltipContent__tableTitle = "_benefitsTooltipContent__tableTitle_3qxv9_117";
const benefitsTooltipContent__tableLabel = "_benefitsTooltipContent__tableLabel_3qxv9_138";
const benefitsTooltipContent__tablePrice = "_benefitsTooltipContent__tablePrice_3qxv9_159";
const styles = {
  benefitsTooltipTitle,
  benefitsTooltipContent,
  benefitsTooltipContent__tableTitle,
  benefitsTooltipContent__tableLabel,
  benefitsTooltipContent__tablePrice,
  "benefitsTooltipContent__table--align-start": "_benefitsTooltipContent__table--align-start_3qxv9_180",
  "benefitsTooltipContent__table--align-end": "_benefitsTooltipContent__table--align-end_3qxv9_183"
};
export {
  benefitsTooltipContent,
  benefitsTooltipContent__tableLabel,
  benefitsTooltipContent__tablePrice,
  benefitsTooltipContent__tableTitle,
  benefitsTooltipTitle,
  styles as default
};
